/* ===================================================================
   HammyTV — theme.js  (vanilla, no dependencies)
   =================================================================== */
(function () {
  "use strict";

  document.addEventListener("DOMContentLoaded", function () {
    initHeaderScroll();
    initMobileNav();
    initSearchModal();
    initCartDrawer();
    initQuickAdd();
    initQtySteppers();
    initProductPage();
    initScrollReveal();
    initTicker();
    initNewsletter();
    refreshCartCount();
  });

  /* ---------- Utilities ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    return "$" + amount.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  var toastTimer;
  function showToast(message) {
    var toast = $("#toast");
    if (!toast) {
      toast = document.createElement("div");
      toast.id = "toast";
      toast.className = "toast";
      document.body.appendChild(toast);
    }
    toast.innerHTML = '<span class="ic">\u2713</span>' + message;
    requestAnimationFrame(function () { toast.classList.add("is-visible"); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.classList.remove("is-visible"); }, 2600);
  }

  function lockScroll(lock) {
    document.body.style.overflow = lock ? "hidden" : "";
  }

  /* ---------- Header scroll shadow ---------- */
  function initHeaderScroll() {
    var header = $(".site-header");
    if (!header) return;
    var onScroll = function () {
      header.classList.toggle("is-scrolled", window.scrollY > 8);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  /* ---------- Mobile navigation drawer ---------- */
  function initMobileNav() {
    var burger = $("#burger");
    var nav = $("#mobile-nav");
    var overlay = $("#overlay");
    if (!burger || !nav) return;

    function open() { nav.classList.add("is-open"); if (overlay) overlay.classList.add("is-open"); burger.setAttribute("aria-expanded", "true"); lockScroll(true); }
    function close() { nav.classList.remove("is-open"); if (overlay) overlay.classList.remove("is-open"); burger.setAttribute("aria-expanded", "false"); lockScroll(false); }

    burger.addEventListener("click", function () {
      nav.classList.contains("is-open") ? close() : open();
    });
    var closeBtn = $("#mobile-nav-close", nav);
    if (closeBtn) closeBtn.addEventListener("click", close);
    if (overlay) overlay.addEventListener("click", close);
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") close(); });

    // Expandable submenus in mobile nav
    $all(".mobile-nav__toggle", nav).forEach(function (btn) {
      btn.addEventListener("click", function () {
        var sub = btn.parentElement.nextElementSibling;
        if (sub) {
          var open = sub.style.display === "block";
          sub.style.display = open ? "none" : "block";
          btn.textContent = open ? "+" : "\u2013";
        }
      });
    });
  }

  /* ---------- Search modal ---------- */
  function initSearchModal() {
    var triggers = $all("[data-search-open]");
    var modal = $("#search-modal");
    if (!modal) return;
    var input = $(".search-form__input", modal);
    var closeBtn = $(".search-modal__close", modal);

    function open() {
      modal.classList.add("is-open");
      lockScroll(true);
      setTimeout(function () { if (input) input.focus(); }, 120);
    }
    function close() { modal.classList.remove("is-open"); lockScroll(false); }

    triggers.forEach(function (t) { t.addEventListener("click", open); });
    if (closeBtn) closeBtn.addEventListener("click", close);
    modal.addEventListener("click", function (e) { if (e.target === modal) close(); });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") close();
      if ((e.key === "k" || e.key === "K") && (e.metaKey || e.ctrlKey)) { e.preventDefault(); open(); }
    });
  }

  /* ---------- Cart drawer ---------- */
  function initCartDrawer() {
    var triggers = $all("[data-cart-open]");
    var drawer = $("#cart-drawer");
    var overlay = $("#overlay");
    if (!drawer) return;
    var closeBtn = $("#cart-drawer-close", drawer);

    window.__openCart = function () {
      drawer.classList.add("is-open");
      if (overlay) overlay.classList.add("is-open");
      lockScroll(true);
      renderCart();
    };
    function close() {
      drawer.classList.remove("is-open");
      if (overlay) overlay.classList.remove("is-open");
      lockScroll(false);
    }
    window.__closeCart = close;

    triggers.forEach(function (t) {
      t.addEventListener("click", function (e) { e.preventDefault(); window.__openCart(); });
    });
    if (closeBtn) closeBtn.addEventListener("click", close);
    if (overlay) overlay.addEventListener("click", close);
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") close(); });
  }

  function renderCart() {
    var body = $("#cart-drawer-body");
    var foot = $("#cart-drawer-foot");
    if (!body) return;
    body.innerHTML = '<div class="cart-drawer__loading">Loading your cart\u2026</div>';

    fetch("/cart.js", { headers: { "Content-Type": "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart.items || cart.items.length === 0) {
          body.innerHTML =
            '<div class="cart-drawer__empty"><div class="emoji">\uD83D\uDED2</div>' +
            "<p>Your cart is empty.</p>" +
            '<a href="/collections/all" class="btn btn--primary" style="margin-top:18px;" onclick="window.__closeCart&&window.__closeCart()">Start shopping</a></div>';
          if (foot) foot.innerHTML = "";
          return;
        }

        var html = "";
        cart.items.forEach(function (item) {
          var img = item.image
            ? '<img class="cart-line__img" src="' + item.image + '" alt="' + escapeHtml(item.product_title) + '">'
            : '<div class="cart-line__img" style="display:flex;align-items:center;justify-content:center;font-size:1.6rem;">\uD83D\uDC55</div>';
          var variant = item.variant_title && item.variant_title !== "Default Title"
            ? '<div class="cart-line__variant">' + escapeHtml(item.variant_title) + "</div>" : "";
          html +=
            '<div class="cart-line" data-key="' + item.key + '">' +
              img +
              "<div>" +
                '<div class="cart-line__title">' + escapeHtml(item.product_title) + "</div>" +
                variant +
                '<div class="cart-line__qty">' +
                  '<button data-qty-down aria-label="Decrease quantity">\u2212</button>' +
                  "<span>" + item.quantity + "</span>" +
                  '<button data-qty-up aria-label="Increase quantity">+</button>' +
                "</div>" +
              "</div>" +
              '<div style="text-align:right;">' +
                '<div class="cart-line__price">' + formatMoney(item.final_line_price) + "</div>" +
                '<button class="cart-line__remove" data-remove aria-label="Remove item" title="Remove"><span aria-hidden="true">\u2715</span></button>' +
              "</div>" +
            "</div>";
        });
        body.innerHTML = html;

        if (foot) {
          foot.innerHTML =
            '<div class="cart-drawer__row"><span>Subtotal</span>' +
            '<span class="cart-drawer__subtotal">' + formatMoney(cart.total_price) + "</span></div>" +
            '<a href="/checkout" class="btn btn--primary btn--full btn--lg">Checkout</a>' +
            '<a href="/cart" class="btn btn--ghost btn--full" style="margin-top:8px;">View full cart</a>' +
            '<p class="cart-drawer__note">Shipping &amp; taxes calculated at checkout</p>';
        }

        bindCartLineEvents();
      })
      .catch(function () {
        body.innerHTML = '<div class="cart-drawer__empty"><p>Couldn\u2019t load your cart. Please refresh.</p></div>';
      });
  }

  function bindCartLineEvents() {
    $all(".cart-line").forEach(function (line) {
      var key = line.getAttribute("data-key");
      var qtyEl = $(".cart-line__qty span", line);
      var current = parseInt(qtyEl.textContent, 10);
      $(".cart-line__qty [data-qty-up]", line).addEventListener("click", function () { updateCart(key, current + 1); });
      $(".cart-line__qty [data-qty-down]", line).addEventListener("click", function () { updateCart(key, Math.max(0, current - 1)); });
      $("[data-remove]", line).addEventListener("click", function () { updateCart(key, 0); });
    });
  }

  function updateCart(key, quantity) {
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function () { renderCart(); refreshCartCount(); })
      .catch(function () {});
  }

  /* ---------- Quick add (product cards) ---------- */
  function initQuickAdd() {
    $all("[data-quick-add]").forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        var id = btn.getAttribute("data-variant-id");
        if (!id) return;
        btn.disabled = true;
        var original = btn.textContent;
        btn.textContent = "Adding\u2026";
        addToCart(id, 1)
          .then(function () {
            btn.textContent = "Added \u2713";
            showToast("Added to cart");
            refreshCartCount();
            setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 1400);
            if (window.__openCart) window.__openCart();
          })
          .catch(function () {
            btn.textContent = "Try again";
            btn.disabled = false;
          });
      });
    });
  }

  function addToCart(id, quantity) {
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: id, quantity: quantity })
    }).then(function (r) {
      if (!r.ok) throw new Error("add failed");
      return r.json();
    });
  }

  /* ---------- Cart count badge ---------- */
  function refreshCartCount() {
    fetch("/cart.js")
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        $all("[data-cart-count]").forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
      })
      .catch(function () {});
  }

  /* ---------- Accordions (PDP) ---------- */

  /* ---------- Quantity steppers (PDP) ---------- */
  function initQtySteppers() {
    $all("[data-qty-stepper]").forEach(function (stepper) {
      var span = $("span", stepper);
      var hidden = $("[data-qty-input]", stepper.parentElement) || $("[data-qty-input]");
      $("[data-qty-minus]", stepper).addEventListener("click", function () {
        var v = Math.max(1, parseInt(span.textContent, 10) - 1);
        span.textContent = v; if (hidden) hidden.value = v;
      });
      $("[data-qty-plus]", stepper).addEventListener("click", function () {
        var v = parseInt(span.textContent, 10) + 1;
        span.textContent = v; if (hidden) hidden.value = v;
      });
    });
  }

  /* ---------- Product page: variants, gallery, ATC ---------- */
  function initProductPage() {
    var form = $("#product-form");
    if (!form) return;

    var variantsData = [];
    var dataEl = $("#variant-data");
    if (dataEl) {
      try { variantsData = JSON.parse(dataEl.textContent); } catch (e) { variantsData = []; }
    }

    var priceEl = $("#pdp-price");
    var atcBtn = $("#pdp-atc");
    var variantIdInput = $("#pdp-variant-id");

    function currentSelections() {
      var opts = [];
      $all("[data-option-index]", form).forEach(function (group) {
        var checked = $("input:checked", group);
        if (checked) opts[parseInt(group.getAttribute("data-option-index"), 10)] = checked.value;
      });
      return opts;
    }

    function matchVariant(selections) {
      return variantsData.find(function (v) {
        return v.options.every(function (opt, i) { return opt === selections[i]; });
      });
    }

    function updateVariant() {
      var sel = currentSelections();
      // reflect the selected value next to each option name (e.g. "Color — Black")
      $all("[data-option-index]", form).forEach(function (group) {
        var checked = $("input:checked", group);
        var valEl = $("[data-opt-value]", group);
        if (checked && valEl) valEl.textContent = checked.value;
      });
      var variant = matchVariant(sel);
      if (!variant) return;
      if (variantIdInput) variantIdInput.value = variant.id;
      if (priceEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceEl.innerHTML =
            '<span class="was">' + formatMoney(variant.compare_at_price) + "</span>" +
            formatMoney(variant.price);
        } else {
          priceEl.textContent = formatMoney(variant.price);
        }
      }
      if (atcBtn) {
        if (variant.available) {
          atcBtn.disabled = false;
          atcBtn.textContent = "Add to cart";
        } else {
          atcBtn.disabled = true;
          atcBtn.textContent = "Sold out";
        }
      }
    }

    $all("[data-option-index] input", form).forEach(function (input) {
      input.addEventListener("change", updateVariant);
    });
    updateVariant();

    // Add to cart submit
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var id = variantIdInput ? variantIdInput.value : null;
      var qtyInput = $("[data-qty-input]", form);
      var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
      if (!id) return;
      atcBtn.disabled = true;
      var orig = atcBtn.textContent;
      atcBtn.textContent = "Adding\u2026";
      addToCart(id, qty)
        .then(function () {
          atcBtn.textContent = "Added \u2713";
          showToast("Added to cart");
          refreshCartCount();
          if (window.__openCart) window.__openCart();
          setTimeout(function () { atcBtn.textContent = orig; atcBtn.disabled = false; }, 1400);
        })
        .catch(function () { atcBtn.textContent = "Try again"; atcBtn.disabled = false; });
    });

    // Gallery thumbnails
    var mainImg = $("#pdp-main-img");
    $all(".pdp__thumb").forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        var src = thumb.getAttribute("data-full");
        if (mainImg && src) {
          mainImg.src = src;
          $all(".pdp__thumb").forEach(function (t) { t.classList.remove("is-active"); });
          thumb.classList.add("is-active");
        }
      });
    });
  }

  /* ---------- Scroll reveal ---------- */
  function initScrollReveal() {
    var els = $all(".reveal");
    if (!els.length || !("IntersectionObserver" in window)) {
      els.forEach(function (el) { el.classList.add("is-visible"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.style.animationDelay = (entry.target.getAttribute("data-delay") || "0") + "ms";
          entry.target.classList.add("is-visible");
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Ticker: duplicate content for seamless loop ---------- */
  function initTicker() {
    $all(".ticker__track").forEach(function (track) {
      track.innerHTML = track.innerHTML + track.innerHTML;
    });
  }

  /* ---------- Newsletter (theme editor preview safe) ---------- */
  function initNewsletter() {
    // Shopify handles the actual submit via customer form; this only enhances UX
    $all(".signup__form").forEach(function (form) {
      form.addEventListener("submit", function () {
        // Allow native submit to proceed; show optimistic note
        var note = form.parentElement.querySelector("[data-newsletter-note]");
        if (note) note.textContent = "Thanks! Check your inbox to confirm. \uD83C\uDF89";
      });
    });
  }

  function escapeHtml(str) {
    if (str == null) return "";
    return String(str)
      .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;").replace(/'/g, "&#39;");
  }
})();
